import { FC } from 'react';
import { useVideoPlayerContext } from '../../contexts/VideoPlayerContext';
import { HStack, IconButton } from '@lib/uikit';

export const VideoPlayerButtons: FC = () => {
    const { buttons } = useVideoPlayerContext();

    return (
        <HStack spacing='xs'>
            {buttons.map((iconButtonProps, index) => (
                <IconButton
                    key={`video-player-button-${index}`}
                    {...iconButtonProps}
                />
            ))}
        </HStack>
    );
};
